import { createLogger, format, transports } from 'winston';

// https://docs.datadoghq.com/logs/log_collection/nodejs/?tab=winston30
export const logger = createLogger({
  level: 'info',
  exitOnError: false,
  format: format.combine(
    format.errors({ stack: true }), // Error 객체 변환 자동 처리
    format.json()
  ),
  transports: [
    new transports.Console({
      format: format.json(),
    }),
  ],
});

export default logger;
